import { portal } from '../platform';
import { openLegal } from '../screens/Legal';

/**
 * Web portals skip the sign-up screens (and so their "by continuing you agree" line), but the game still creates a guest
 * account on our servers, so new players get a plain, non-blocking notice instead.
 */
export function PortalNotice() {
  if (!portal) return null;
  return (
    <p class="portal-notice">
      By playing you agree to our{' '}
      <button class="linkish" onClick={() => openLegal('terms')}>
        Terms
      </button>{' '}
      and{' '}
      <button class="linkish" onClick={() => openLegal('privacy')}>
        Privacy Policy
      </button>
      .
    </p>
  );
}
